import React from 'react';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

// Shared dashboard tile primitive used by the staff dashboard, the parent
// dashboard, and the parent account page. White-on-color page backgrounds
// (the lime parent layout especially) flatten the legacy `sectionColor`
// tiles into the page; this primitive lifts off the background with a real
// shadow + crisp border so cards stay distinct on any backdrop.
const Surface = styled(Paper)`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 24px;
  margin-bottom: 16px;

  & > *:first-child,
  & > form:first-child > *:first-child {
    margin-top: 0;
  }
  & > *:last-child,
  & > form:last-child > *:last-child {
    margin-bottom: 0;
  }
`;

interface IDashboardCardProps {
  className?: string;
  children: React.ReactNode;
}

export const DashboardCard: React.FC<IDashboardCardProps> = ({ className, children }) => (
  <Surface elevation={3} className={className}>{children}</Surface>
);
